











import Vue from 'vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import EventBus from '@/eventBus.js';

export default Vue.extend({
    name: 'CoCopy',
    inheritAttrs: false,
    i18n: {
        messages: {
            en: {
                ariaLabel: 'Copy to clipboard',
                copiedToClipboard: 'Copied to clipboard',
                copyFailed: 'Could not copy to clipboard',
            },
            de: {
                ariaLabel: 'In die Zwischenablage kopieren',
                copiedToClipboard: 'In die Zwischenablage kopiert',
                copyFailed: 'Konnte nicht in die Zwischenablage kopieren',
            },
        },
    },
    components: {
        CoRoundButton,
    },
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    methods: {
        async copyToClipboard() {
            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(this.text);
                } else {
                    const textarea = document.createElement('textarea');
                    textarea.value = this.text;
                    textarea.setAttribute('readonly', '');
                    textarea.style.position = 'absolute';
                    textarea.style.left = '-9999px';
                    textarea.style.top = '0';
                    textarea.style.opacity = '0';

                    document.body.appendChild(textarea);
                    textarea.focus();
                    textarea.select();
                    const copied = document.execCommand('copy');
                    document.body.removeChild(textarea);

                    if (!copied) {
                        throw new Error('Copy command was not successful');
                    }
                }

                EventBus.$emit('INFO', {
                    Message: this.$t('copiedToClipboard'),
                    Details: '',
                });

                this.$emit('copied');
            } catch (error) {
                EventBus.$emit('ERROR', {
                    Message: this.$t('copyFailed'),
                });

                this.$emit('copy-error', error);
            }
        },
    },
});
